var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgProof = function SvgProof(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 138.965256,
    x2: 86,
    y2: 145.576508,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 25.53125,
    x2: 86,
    y2: 33.703941,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 53.414059,
    x2: 86,
    y2: 72.898438,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 15.11719,
    x2: 86,
    y2: 157.675629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9271690"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 10.15625 40.625 L 39.84375 40.625 L 39.84375 42.1875 L 10.15625 42.1875 Z M 10.15625 40.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 10.15625 7.8125 L 39.84375 7.8125 L 39.84375 9.375 L 10.15625 9.375 Z M 10.15625 7.8125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 34.015625 15.625 C 32.320312 18.875 28.914062 21.09375 25 21.09375 C 21.085938 21.09375 17.679688 18.875 15.984375 15.625 Z M 34.015625 15.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 39.761719 12.5 L 40.625 12.5 C 41.917969 12.5 42.96875 11.449219 42.96875 10.15625 L 42.96875 7.03125 C 42.96875 5.738281 41.917969 4.6875 40.625 4.6875 L 9.375 4.6875 C 8.082031 4.6875 7.03125 5.738281 7.03125 7.03125 L 7.03125 10.15625 C 7.03125 11.449219 8.082031 12.5 9.375 12.5 L 10.238281 12.5 C 10.855469 18.347656 14.878906 23.183594 20.28125 25 C 14.878906 26.816406 10.855469 31.652344 10.238281 37.5 L 9.375 37.5 C 8.082031 37.5 7.03125 38.550781 7.03125 39.84375 L 7.03125 42.96875 C 7.03125 44.261719 8.082031 45.3125 9.375 45.3125 L 40.625 45.3125 C 41.917969 45.3125 42.96875 44.261719 42.96875 42.96875 L 42.96875 39.84375 C 42.96875 38.550781 41.917969 37.5 40.625 37.5 L 39.761719 37.5 C 39.144531 31.652344 35.121094 26.816406 29.71875 25 C 35.117188 23.183594 39.144531 18.347656 39.761719 12.5 Z M 9.375 10.9375 C 8.945312 10.9375 8.59375 10.585938 8.59375 10.15625 L 8.59375 7.03125 C 8.59375 6.601562 8.945312 6.25 9.375 6.25 L 40.625 6.25 C 41.054688 6.25 41.40625 6.601562 41.40625 7.03125 L 41.40625 10.15625 C 41.40625 10.585938 41.054688 10.9375 40.625 10.9375 Z M 40.625 39.0625 C 41.054688 39.0625 41.40625 39.414062 41.40625 39.84375 L 41.40625 42.96875 C 41.40625 43.398438 41.054688 43.75 40.625 43.75 L 9.375 43.75 C 8.945312 43.75 8.59375 43.398438 8.59375 42.96875 L 8.59375 39.84375 C 8.59375 39.414062 8.945312 39.0625 9.375 39.0625 Z M 35.714844 31.25 L 32.03125 31.25 L 32.03125 32.8125 L 36.710938 32.8125 C 36.980469 33.3125 37.207031 33.839844 37.410156 34.375 L 28.90625 34.375 L 28.90625 35.9375 L 37.894531 35.9375 C 38.019531 36.449219 38.117188 36.96875 38.179688 37.5 L 11.820312 37.5 C 12.566406 31.167969 17.78125 26.199219 24.21875 25.820312 L 24.21875 28.90625 L 25.78125 28.90625 L 25.78125 25.820312 C 29.859375 26.058594 33.445312 28.140625 35.714844 31.25 Z M 25 24.21875 C 18.207031 24.21875 12.597656 19.089844 11.820312 12.5 L 38.179688 12.5 C 37.402344 19.089844 31.792969 24.21875 25 24.21875 Z M 25 24.21875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProof, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/proof.b2b2665f.svg";
export { ForwardRef as ReactComponent };